export default __webpack_public_path__ + "static/minutemedia-1e8803f968227e173944c1e323b1309b.svg";